/** @jsx jsx */
import { Box, Flex, Paragraph } from "@eworkit/iris";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { Answer } from "@/data/questionnaire/types/Answer";

interface SingleAnswerProps {
  answer: Answer;
}

export const SingleAnswer: FunctionComponent<SingleAnswerProps> = ({ answer }) => {
  const { t } = useTranslation("session");

  return (
    <Flex gap="xs" flexDirection="column" key={answer.question.id}>
      <Paragraph bold>{answer.question.question}</Paragraph>
      <Box
        sx={{
          borderLeftStyle: "solid",
          borderLeftColor: answer.answer === true ? "g500" : "n700",
          borderLeftWidth: 2,
        }}
        pl="sm">
        <Paragraph bold color={typeof answer.answer === "boolean" && answer.answer ? "g500" : "n700"}>
          {typeof answer.answer === "boolean"
            ? answer.answer
              ? t("JOB_APPLICATIONS.DETAIL.QUESTIONNAIRE.YES_ANSWER")
              : t("JOB_APPLICATIONS.DETAIL.QUESTIONNAIRE.NO_ANSWER")
            : t("JOB_APPLICATIONS.DETAIL.QUESTIONNAIRE.NONE_ANSWER")}
        </Paragraph>
        <br />
        {answer.elaboration && <Paragraph color="n700">{answer.elaboration}</Paragraph>}
      </Box>
    </Flex>
  );
};
